module.exports = __webpack_public_path__ + "static/media/member-exclusive-page.52dd3954.png";